const ru = {
    system_catalog: "Каталог систем",
    help_search_detail: "Возможно, вы имели в виду",
    header_text: "Мотордата Нормы времени",
    login_info: "Еще не зарегистрированы",
    load_text: "Поиск...",
    error_text: "Ошибка",
    license_plate_error: "Возможно, введен неверный госномер",
    license_plate_label: "Введите госномер",
    license_plate_info: "Госномер",
    close_btn: "Закрыть",
    ERROR_ORDER_JOB_LIMIT: "Достигнут лимит по количеству работ для данного автомобиля",
    ERROR_ORDER_SYSTEM_EMPTY: "Не указана система для новой работы",
    ERROR_ORDER_CREATE_PART: "Ошибка при создании норматива",
    ERROR_ORDER_PART_NOT_FOUND: "Указанный норматив отсутствует!",
    ERROR_FRIEND_LIMIT_REACHED:"Превышено максимальное количество партнёров",
    ERROR_UNAUTHORIZED:"Ошибка не пользователь не авторизован",
    ERROR_INVALID_LICENSE:"Ошибка лицензия неактивная"
};

export default ru;